import { useDeleteCardsWithConfirmation } from '@vlabs/monokit/features/delete-cards';
import type { Card } from '@vlabs/api/point-api/model';
import { PersonCard } from '@vlabs/monokit/shared/ui/person-card';
import { useTranslation } from 'react-i18next';

import { CardsBulkActions } from '../bulk-actions';
import st from './CardListGridView.module.sass';

interface CardListGridViewProps {
  data?: Card[];
  onSelect?: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
  selectedCardList?: Record<string, boolean>;
}

function CardListGridView({
  data = undefined,
  selectedCardList = undefined,
  onSelect = undefined,
}: CardListGridViewProps): React.JSX.Element {
  const { t } = useTranslation();
  const selectedCount = Object.values(selectedCardList ?? {}).filter((isSelected) => isSelected).length;
  const deleteCardsHandler = useDeleteCardsWithConfirmation({
    cardIds: Object
      .entries(selectedCardList ?? {})
      .filter(([_, isSelected]) => isSelected)
      .map(([externalId]) => externalId),
  });

  if (data?.length === 0) {
    return (
      <div className={st.EmptyList}>
        {t('no data.title')}
      </div>
    );
  }

  return (
    <div className={st.Root}>
      {selectedCount > 0 && (
        <CardsBulkActions
          indeterminate={data?.length !== selectedCount}
          onCancel={() => onSelect?.({})}
          onCheckboxClick={() => onSelect?.({})}
          onDelete={deleteCardsHandler}
          selectedCount={selectedCount}
        />
      )}
      <div className={st.CardListGrid}>
        {data?.map((card) => (
          <PersonCard
            isSelected={selectedCardList?.[card.card_id as string] ?? false}
            key={card.card_id}
            onSelect={() => {
              onSelect?.({
                ...selectedCardList,
                [card.card_id as string]: !(selectedCardList?.[card.card_id as string] ?? false),
              });
            }}
            card={card}
          />
        ))}
      </div>
    </div>
  );
}

export { CardListGridView };
